<template>
  <y-block-box title="下载数据" class="overflow-auto" style="height: 40%;flex-shrink: 0;">
    <template #suffix>
      <btn-change-group :items="btnItems" v-model="daySpan"></btn-change-group>
    </template>
    <div class="download-data-box" v-loading="loading">
      <div v-for="item in renderData" class="download-item">
        <div class="rank-item">
          <img v-if="item.src" :src="item.src" style="width: 100%;">
          <div v-else>{{item.index}}.</div>
        </div>
        <y-spacer>
          <div :title="item.title" class="download-item-title">{{item.title}}</div>
          <div class="progress-item">
            <div class="blue-progress" :style="`width:${item.relativeRate}%;`">
              {{item.countText}}
            </div>
          </div>
        </y-spacer>
        <div>{{item.trafficText}}</div>
      </div>
    </div>
  </y-block-box>
</template>

<script>
export default {
  name: "DownloadData",
  data(){
    return{
      renderData:[],
      btnItems:[
        {text:'近一周',value:7},
        {text:'近30天',value:30},
      ],
      daySpan:7,
      loading:false,
    }
  },
  mounted() {},
  watch:{
    daySpan:{
      handler(){
        this.queryData();
      },
      immediate:true
    }
  },
  methods:{
    async queryData(){
      this.loading = true
      let res = await this.$callApi("board.getCdnTop", {day:this.daySpan});
      const resData = res.data;
      const countSum = resData.reduce((total, item) => total + item.count, 0);
      // 先计算所有countRate
      const itemsWithRate = resData.map((item) => ({
        ...item,
        countRate: item.count / countSum
      }));

      // 找到最大的countRate
      const maxRate = Math.max(...itemsWithRate.map(item => item.countRate));

      // 然后计算相对于最大值的比例
      this.renderData = itemsWithRate.map((item, index) => {
        const title = item.url.split('/').pop();

        const req = {
          index: index + 1,
          title, // 资源名
          countText: item.countText, // 访问次数
          trafficText: item.trafficText, // 下载流量
          countRate: item.countRate,
          // 计算相对于最大值的比例
          relativeRate: (item.countRate / maxRate) * 100
        };

        if (req.index < 4) {
          req.src = require(`./images/${req.index}.png`);
        }

        return req;
      });
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/variables.less';

.download-data-box{
  display: flex;
  flex-direction: column;
  gap: 18px;
  height: 100%;
}
.download-item{
  display: flex;
  align-items: center;
  gap: 14px;
  .download-item-title{
    white-space: nowrap;      /* 禁止换行 */
    overflow: hidden;         /* 隐藏溢出内容 */
    text-overflow: ellipsis;  /* 显示省略号 */
    color: #161823;
    font-weight: bold;
  }
}
.rank-item{
  width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-style: italic; /* 使用字体的斜体版本 */
  font-weight: bold;
  color: #24170F;
}
.progress-item{
  color: #717279;
  background: #F1F1F2;
  border-radius: 8px;
  position: relative;
  &:before{
    content: '';
    border-radius: 8px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: inset 0 0 4px 0 #E6E6E6;
  }
  .blue-progress{
    background: linear-gradient(to right,#0068FF,#0082FF);
    //box-shadow: inset 0 0 6px 0 #003cb4;
    color: #ffffff;
    padding: 0px 12px;
    min-width: max-content;
    border-radius: 8px;
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/board/components/DownloadData/DownloadData.vue